import React from 'react';
import BlogPosts from '../components/site/BlogPosts';
import { PageHero, PageShell } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

export default function BlogIndex() {
  useSeo({
    title: 'Blog | Merch Production & Live Printing Insights | Pusha Teez',
    description: 'Tips, playbooks and real-world lessons from Pusha Teez on merch production and live merch printing.',
    path: '/blog',
  });
  return (
    <PageShell testid="blog-index-page">
      <PageHero eyebrow="Blog" title="Insights &" accent="Stories" intro="Tips, playbooks, and real-world lessons from running live merch printing activations for brands, artists, and events across the country." />
      <BlogPosts hideHeading />
    </PageShell>
  );
}
